import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { CAL_DEMO_BOOKING_URL } from '@app/config';
import { SharedModule } from '@app/shared';
import { environment } from '@env/environment';
import { WA_WINDOW } from '@ng-web-apis/common';
import {
  TuiAppearance,
  TuiButton,
  TuiDataList,
  TuiDropdown,
  TuiIcon,
  TuiPopup,
} from '@taiga-ui/core';
import { TuiBadgedContent, TuiChevron, TuiDrawer } from '@taiga-ui/kit';
import { fromEvent } from 'rxjs';
import { FaIconModule } from '../fa-icon/fa-icon.module';
import { SidebarComponent } from '../sidebar/sidebar.component';

interface NavItem {
  href?: string;
  label: string;
  target?: '_blank' | '_self';
  expanded?: WritableSignal<boolean>;
  items?: {
    href: string;
    label: string;
    description: string;
    icon: string;
    target: '_blank' | '_self';
  }[];
}

@Component({
  selector: 'app-header',
  imports: [
    FaIconModule,
    SharedModule,
    SidebarComponent,
    TuiAppearance,
    TuiBadgedContent,
    TuiButton,
    TuiChevron,
    TuiDataList,
    TuiDrawer,
    TuiDropdown,
    TuiIcon,
    TuiPopup,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
  protected readonly navItems: NavItem[] = [
    {
      label: 'Product',
      expanded: signal(false),
      items: [
        {
          href: '/live-updates',
          label: 'Live Updates',
          description: 'Deploy real-time app updates',
          icon: '@tui.zap',
          target: '_self',
        },
        {
          href: '/native-builds',
          label: 'Native Builds',
          description: 'Build native apps in the cloud',
          icon: '@tui.blocks',
          target: '_self',
        },
        {
          href: '/app-store-publishing',
          label: 'App Store Publishing',
          description: 'Publish apps to app stores',
          icon: '@tui.store',
          target: '_self',
        },
      ],
    },
    {
      href: '/pricing/',
      label: 'Pricing',
      target: '_self',
    },
    {
      href: '/enterprise/',
      label: 'Enterprise',
      target: '_self',
    },
    {
      href: '/trust/',
      label: 'Security',
      target: '_self',
    },
  ];
  protected readonly sidedarOpen = signal(false);
  protected dropdownsOpen = false;

  constructor(@Inject(WA_WINDOW) private readonly window: Window) {
    const resizeObservable$ = fromEvent(window, 'resize');
    resizeObservable$.subscribe(event => {
      this.onResize(event);
    });
  }

  protected onDropdownItemClick(): void {
    this.dropdownsOpen = false;
  }

  public onToggleSidebar(active: boolean): void {
    this.sidedarOpen.set(active);
  }

  public onResize(event: any): void {
    const width = event?.target?.innerWidth;
    if (!width || width >= 1024) {
      this.sidedarOpen.set(false);
    }
  }
}
